import Api from "@/services/Api";
import BaseApi from "../../../services/baseApi";
class Unit_se {
    constructor() {
        this.entity = 'guest';
    }

    delete(id) {
        return Api.delete(this.entity,id)
    }


    getById(id) {
        if(id && id.length>0) {
            return Api.getById(this.entity, id)
        }else {
            return Api.new_(this.entity)
        }
    }
    selectGuest(id) {
        return BaseApi({requiresAtuh: true})({
            method: 'GET',
            url: '/private/'+this.entity+'/select/?id='+id,
            headers: {'Content-Type': 'application/json'},
        })
    }

    getPage(page_,size_) {
        return Api.getPage(this.entity,page_,size_)
    }
    save(model) {
        return Api.save(this.entity,model)
    }

    getUnits(buildingId){
        let formData=new FormData();
        formData.set("buildingId", buildingId)
        return BaseApi({requiresAtuh: true})({
            method: 'POST',
            data: formData,
            url: '/private/establishment/units/',
            headers: {'Content-Type': 'application/json'},
        })
    }


    search(part1,part2,part3,part4,unitId,page_,size_){
        let formData=new FormData();
        formData.set("page",page_)
        formData.set("size", size_)
        formData.append("part1",part1)
        formData.append("part2",part2)
        formData.append("part3",part3)
        formData.append("part4",part4)
        formData.append("unitId",unitId)
        return BaseApi({requiresAtuh: true})({
            method: 'POST',
            data:formData,
            url: '/private/'+this.entity+'/search',
            headers: {'Content-Type': 'application/json'},
        })
    }






}
export default new Unit_se();
